import type { AppState } from 'types/app';

export const selectFilters = (state: AppState) => state?.filters;

export const selectSelectedFilters = (state: AppState) => selectFilters(state)?.selected;

export const selectSearchTerm = (state: AppState) => selectFilters(state)?.term;
